import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import type { HeaderWidgetParams } from '@/types/chatbot.types';
import HeaderTextWidget from './HeaderTextWidget';
import { getWidgetIcon } from './widgetIcons';
import * as S from './widgets.styles';

/**
 * Header widget component for displaying titles with optional suffix icons/badges
 */
const HeaderWidget: React.FC<HeaderWidgetParams> = observer(
  ({ title, titleVariant, suffixIconName, shouldStart, onAnimationComplete }) => {
    // Memoize icon component to avoid re-computing on every render
    const IconComponent = useMemo(() => {
      if (!suffixIconName) return null;
      return getWidgetIcon(suffixIconName);
    }, [suffixIconName]);

    if (!title) return null;

    const variant = titleVariant || 'h4';

    return (
      <S.HeaderWidgetContainer>
        <HeaderTextWidget
          content={title}
          variant={variant}
          shouldStart={shouldStart}
          onAnimationComplete={onAnimationComplete}
        />
        {IconComponent && <IconComponent />}
      </S.HeaderWidgetContainer>
    );
  },
);

HeaderWidget.displayName = 'HeaderWidget';

export default HeaderWidget;
